// src/utils/shiftDate.js
// Utilities to normalize shiftDate storage as plain ISO date strings (YYYY-MM-DD)
export function toIsoDateString(dateLike) {
  if (!dateLike) return null;
  // Accept Firestore Timestamp-like objects (.toDate), Date objects, or an ISO string
  let d;
  if (dateLike.toDate) d = dateLike.toDate();
  else if (typeof dateLike === 'string') {
    // If already YYYY-MM-DD, keep as-is; otherwise attempt to parse
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateLike)) return dateLike;
    d = new Date(dateLike);
  } else {
    d = new Date(dateLike);
  }
  if (Number.isNaN(d.getTime())) return null;
  // Use local date components so the ISO day corresponds to the local/business date
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function toDate(dateLike) {
  if (!dateLike) return null;
  if (dateLike.toDate) return dateLike.toDate();
  if (typeof dateLike === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateLike)) {
    // Treat YYYY-MM-DD as a local (business) date at local midnight
    const [y, m, d] = dateLike.split('-').map(Number);
    return new Date(y, m - 1, d, 0, 0, 0, 0);
  }
  return new Date(dateLike);
}

export function ensureIsoForWrite(dateLike) {
  // Returns YYYY-MM-DD string suitable for storing as shiftDate
  return toIsoDateString(dateLike);
}
